type CalendarConfigType = {
    weekStartsOn: 0 | 1 | 2 | 3 | 4 | 5 | 6;
};

export const CALENDAR_CONFIG: CalendarConfigType = {
    weekStartsOn: 1, // week starts on monday
};
